export default __webpack_public_path__ + "static/media/CSRealCase3-moblie.70bc2ade.jpg";